export const DEFAULT_RTP = 96;



